<template>
  <div >
    <v-select
      v-bind="$attrs"
      v-on="$listeners"
      :label="$t('core.routing_key')"
      :items="items"
      item-value="value"
      item-text="text"
      :prepend-inner-icon="routingkey == 'quarantine' ? 'mdi-alert' : ''"
    />
  </div>
</template>
<script>
import LocalStorageService from '../../services/LocalStorageService'

export default {

  name: 'RoutingkeySelect',

  data: () => ({ isMaster: false }),

  computed: {
    routingkey: {
      get () { return this.$attrs.value },
      set (value) { this.$emit('input', value) }
    },
    items () {
      return [
        {
          text: 'SANDBOX',
          value: 'sandbox'
        },
        {
          text: 'HOMOLOG',
          value: 'homolog'
        },
        {
          text: 'COMMUNITY',
          value: 'community'
        },
        {
          text: 'ENTERPRISE',
          value: 'enterprise'
          // exclusive: true // This prop will to this option just be selectable by MASTERs
        },
        {
          text: 'THREAD-DEDICATED',
          value: 'allinone'
        },
        {
          text: 'QUARANTINE',
          value: 'quarantine'
        },
        {
          text: 'exclusive',
          value: 'exclusive',
          exclusive: true // This prop will to this option just be selectable by MASTERs
        }
      ].filter(i => !i?.exclusive || this.isMaster || i.value === this.$attrs.value)
    },
    realRoutingkey () { return this.items.some(i => i.value === this.routingkey) } // Return if the 'routingkey' is a real routingkey
  },

  methods: {
    updateIsMaster () {
      const permissions = LocalStorageService.getUserDetails()?.permissions ?? []
      const isMaster = permissions.includes('MASTER')
      if (isMaster !== this.isMaster) this.isMaster = isMaster
    }
  },

  updated () { this.updateIsMaster() },

  mounted () { this.updateIsMaster() },

  watch: {
    routingkey: {
      immediate: true,
      handler () {
        if (this.realRoutingkey) return
        if (this.routingkey === undefined) return
        this.routingkey = undefined
      }
    }
  }

}
</script>
